/* istanbul ignore file */

import React from 'react';

import * as styles from '../styles';

export interface ProductsViewedProps {
  numberOfProductsViewed: number;
  totalNumberOfProducts: number;
  isDivider?: boolean;
}

export const PRODUCTS_VIWED__SPAN = 'PRODUCTS_VIWED__SPAN';

export const ProductsViewed = ({
  numberOfProductsViewed,
  totalNumberOfProducts,
  isDivider = false,
}: ProductsViewedProps) => (
  <p css={styles.productsViewedWrapper} data-is-divider={isDivider}>
    <span css={styles.productsViewedText} data-testid={PRODUCTS_VIWED__SPAN}>
      Viewed {numberOfProductsViewed} of {totalNumberOfProducts} products
    </span>
  </p>
);
